<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="jointOrder" :label="$t('status.joint.jointNumber')" />
      <!-- <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" /> -->
      <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetId?.length > 4  && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetId)">{{scope.row.cabinetId}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetId}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="servoVersion" :label="$t('status.joint.servoVersion')" />
      <el-table-column prop="temperature" :label="$t('status.joint.temperatureCelsius')" />
      <el-table-column prop="voltage" :label="$t('status.joint.voltageVolt')" />
      <el-table-column prop="currentFluctuation" :label="$t('status.joint.currentFluctuationPercent')" />
      <el-table-column prop="averagePower" :label="$t('status.joint.operatingPowerWatt')" />
      <el-table-column prop="sumRunningCircles" :label="$t('status.joint.totalJointRevolutions')" />
      <el-table-column prop="queryTime" :label="$t('error.alarm.queryTime')" width="180" />
      <el-table-column :label="$t('activity.list.operation')" width="150">
        <template #default="scope">
          <el-button v-show="authList.includes('joint:detail')" type="text" size="mini" @click="jointCharts(scope.row)">{{$t('status.joint.jointStatusDiagram')}}</el-button>
          <el-button type="text" size="mini" @click="handleClick(scope.row)"
            >{{$t('event.crash.refreshStatus')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
// import { useRouter } from 'vue-router'
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data() {
    return {
      params: [{
        key: 'robotId',
        value: '',
        label: this.$t('activity.packetjoin.robotCode')
      },{
        key: 'cabinetId',
        value: '',
        label: this.$t('collect.healthscorelist.ctrlCabCode')
      }],
      query: {
        robotId: "",
        cabinetId: "",
        robotStatus: "",
        cabinetName: "",
        companyName: "",
        isCrash: "",
        isEmergency: "",
      },
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      authList: JSON.parse(window.localStorage.getItem('authList'))
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      request("getJointStatus", {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then((data) => {
          this.tableDataList = data.records;
          this.total = data.total;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getDataMap() {
      try {
        request("getArea", {
          parentId: 1,
        }).then((data) => {
          this.provinceList = data;
        });
        request("getRobotStatusMap").then((data) => {
          this.robotStatusList = data;
        });
        request("getIndustryList").then((data) => {
          this.industryList = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleClick() {
      this.getData();
    },
    searchData(data) {
      this.query = data
      this.getData()
    },
    updatePage(page, size) {
        this.page = page || 1
        this.size = size || 10
        this.getData()
    },
    jointCharts(row) {
      // const router = useRouter()
      this.$router.push({ path: '/status/jointChart', query: { robotId: row.robotId, jointId: row.jointOrder} })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
